import React, {useEffect, useState} from "react";
import {useParams} from "react-router-dom";
import axios from "axios";
import s from "./NewsView.module.scss";
import {Helmet} from "react-helmet-async";
import {Aside} from "../../components/Aside/Aside";
import titleImage from "../../assets/images/titleImage.png";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import LoadingInside from "../../components/Loading/LoadingInside";

const API_URL = process.env.REACT_APP_API_LOCAL_URL;

const NewsView = () => {
    const {id} = useParams();

    const [news, setNews] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchNews();
    }, [id]);

    const decodeBase64 = (str) => {
        try {
            return str ? atob(str) : "";
        } catch {
            return "";
        }
    };

    const fetchNews = async () => {
        try {
            const res = await axios.get(`${API_URL}news/${id}`);
            setNews(res.data.data || res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return  <LoadingInside height={"90vh"}/>;
    if (!news) return <div>News not found</div>;

    const breadcrumbItems = [
        {name: "ホーム", link: "/"},
        {name: "キャンペーン", link: "/news"},
        {name: news.newsTitle}
    ];

    return (
        <>
            <Helmet>
                <title>{news.newsTitle}</title>
                <meta property="og:title" content={news.newsTitle}/>
                {/*<meta property="og:image" content={news.banner}/>*/}
                <meta
                    property="og:url"
                    content={`${process.env.REACT_APP_URL}/news/${news.id}`}
                />
                <meta name="description" content={news.newsTitle}/>
            </Helmet>
            <div className={"row mt-3"}>
                <div className={"col-12"}>
                    <Breadcrumb items={breadcrumbItems}/>
                    <div className={s.titleContainer}>
                        <h2><img className={s.titleImage} src={titleImage}/>{news.newsTitle}</h2>
                    </div>
                </div>
            </div>
            <div className={"row mt-5"}>
                <div className={"col-12 col-md-8"}>
                    {/*{news.banner && (*/}
                    {/*    <img*/}
                    {/*        src={news.banner}*/}
                    {/*        alt={news.newsTitle}*/}
                    {/*        className={s.cardImage}*/}
                    {/*    />*/}
                    {/*)}*/}

                    {/* custom css */}
                    <style>
                        {
                            (() => {
                                const decodedCss = JSON.parse(
                                    decodeURIComponent(escape(atob(news.css || "")))
                                );

                                const cleanedCss = decodedCss.replace(
                                    /body\s*\{[^}]*\}/gi,
                                    ""
                                );

                                return <style>{cleanedCss}</style>;
                            })()
                        }
                    </style>

                    {/* prefer html, fallback to description */}
                    {news.html? (
                        <div
                            dangerouslySetInnerHTML={{
                                __html: JSON.parse(decodeURIComponent(escape(atob(news.html || ""))))
                            }}
                        />
                    ) : (
                        <div

                        />
                    )}
                </div>
                <div className={"col-12 col-md-4"}>
                    <Aside/>
                </div>
            </div>

        </>
    );
};

export default NewsView;